<template>
    <div ref="slickGallery" id="galleryCarousel" class="used-slick-gallery aos-gallery__container">
        <template v-if="images.length > 0">
            <figure v-for="(image, key) in images" itemprop="associatedMedia" class="used-slick-gallery__item" itemscope itemtype="http://schema.org/ImageObject" :key="key">
                <a ref="image" :data-index="key" :href="image.src" @click.prevent="$photoswipe.open($refs.image ,key, images)" itemprop="contentUrl">
                    <img class="img-responsive used-slick-gallery__img" :src="image.src" itemprop="thumbnail" :alt="'Used ' + vehicle.vehicle_title + ' Photo #'+ key">
                </a>
            </figure>
        </template>
        <template v-else>
            <figure itemprop="associatedMedia" class="gallery-item used-slick-gallery__item" itemscope itemtype="http://schema.org/ImageObject">
                <a href="/images/used/image-coming-soon@2x.jpg" @click.prevent="$photoswipe.open($refs.image ,key, images)" itemprop="contentUrl" :data-index="1">
                    <picture>
                        <source srcset="/images/used/image-coming-soon.webp, /images/used/image-coming-soon@2x.webp 2x" type="image/webp">
                        <img class="img-responsive" srcset="/images/used/image-coming-soon.jpg, /images/used/image-coming-soon@2x.jpg 2x" itemprop="thumbnail" :alt="'Used ' + vehicle.vehicle_title + ' Photo Coming Soon'">
                    </picture>
                </a>
            </figure>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import VuePhotoSwipe from '../../core/components/Photoswipe';
require('jquery');
require('slick-carousel');

Vue.use(VuePhotoSwipe);

export default {
    props: {
        vehicle: {
            default: [],
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        images() {
            const usedVehiclesInternalImagesLength = this.vehicle.used_vehicles_internal_images.length;
            if (usedVehiclesInternalImagesLength == 0) {
                return [];
            }
            let images = [];
            for (let index = 0, len = usedVehiclesInternalImagesLength; index < len; index++) {
                images.push({
                    src: this.vehicle.used_vehicles_internal_images[index].fullsize_path,
                    w: this.vehicle.used_vehicles_internal_images[index].width,
                    h: this.vehicle.used_vehicles_internal_images[index].height
                });
            }
            return images;
        },
    },
    mounted() {
        $(this.$refs.slickGallery).slick({
            arrows: true,
            dots: false,
            infinite: true,
            speed: 200,
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            autoplay: false,
            prevArrow: '<svg viewBox="0 0 134.258 404.258" xmlns="http://www.w3.org/2000/svg" class="left-arrow slick-prev"><path fill="none" d="M-1-1h136.258v406.258H-1z"/><path d="M121.132332 46.561615l-14.627869-15.483742-92.396885 173.872971 92.396885 173.872955 14.627869-15.483734-84.16872-158.389221" stroke-opacity="null" stroke-linecap="null" stroke-linejoin="null" stroke-width="null" stroke="null" fill-opacity="null" fill="null"/></svg>',
            nextArrow: '<svg viewBox="0 0 134.258 404.258" xmlns="http://www.w3.org/2000/svg" class="right-arrow slick-next"><path fill="none" d="M-1-1h136.258v406.258H-1z"/>  <path d="M14.10758194 363.34005736l14.627869 15.483742 92.396885-173.872971-92.396885-173.872955-14.627869 15.483734 84.16872 158.389221" stroke-opacity="null" stroke-linecap="null" stroke-linejoin="null" stroke-width="null" stroke="null" fill-opacity="null" fill="null"/></svg>',
        });
    },
    beforeDestroy() {
        $(this.$refs.slickGallery).slick('destroy');
    }
}
</script>

<style lang="scss">
    @import "../../../sass/slick/slick";
    @import "../../../sass/used/utilities/details/_autotrader-gallery.scss";
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/SlickGallery.vue